import { useState, useContext, useMemo, useRef, useEffect } from 'react';
import moment from 'moment';

import { LoginContext } from '../context/login-context';

import useProtectedQuery from '../hooks/use-protected-query';
import useProtectedMutation from '../hooks/use-protected-mutation';

import RebatesClient from '../RebatesClient';

export default function useStrategicAccounts(props) {
    const {
        data: strategicAccounts,
        isLoading: strategicAccountsLoading,
        error: strategicAccountsError,
        refetch: refetchStrategicAccounts
    } = useProtectedQuery({
        queryKey: ['get_strategic_accounts',],
        queryFn: async () => {
            let url = '/api/accounts/get-strat-accounts';


            const result = await RebatesClient.standardFetch(url)

            if (result.response.ok) {
                return result.body
            }
            else {
                throw new Error("Error getting strategic account");
            }

        },
    });

    function flattenStratAccounts() {
        const flatten = (accts) => {
          return accts?.reduce((acc, account) => {
            if (account.account_type === "STRATEGIC_ACCOUNT" || account.account_type === "SUB_ENTITY") {
               acc.push(account);
              if (account.children_accounts?.length) {
                acc = acc.concat(flatten(account.children_accounts));
              }         
            }
            return acc;
          }, [])
        };
  
        const flattenedAccounts = flatten(strategicAccounts);
   
        const updatedNames = structuredClone(flattenedAccounts)?.map((account) => {
          const parent = structuredClone(flattenedAccounts).find(a => a.id === account.parent_account_id) || null;
          const parent2 = structuredClone(flattenedAccounts).find(a => a.id === parent?.parent_account_id) || null;
          if (parent && account.account_type === "SUB_ENTITY") {
            if (parent2 && account.account_type === "SUB_ENTITY") {
              account.name = `${parent2.name} / ${parent.name} / ${account.name}`;
            }
            else {
              account.name = `${parent.name} / ${account.name}`;
            }
          }
          return account;
        })
  
        return updatedNames;
      }
    



    return {
        flattenStratAccounts,
        strategicAccounts,
        strategicAccountsLoading,
        strategicAccountsError,
        refetchStrategicAccounts,
    }
}
